export default __webpack_public_path__ + "static/media/a3.9b651824.png";